<template>
    <div class="popup">
        <van-popup :value="show" @click-overlay="close" @open="open">
            <div class="content">
                <div class="header">
                    <span> {{ $t("person.PersonalCenter") }} </span>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" role="presentation" class="icon-base_root-F1flk icon-base_m-F1flk" data-icon="close" @click="close">
                        <path fill="currentColor"
                            d="M3.364 3.364a.9.9 0 0 1 1.272 0L8 6.727l3.364-3.363a.9.9 0 0 1 1.272 1.272L9.274 8l3.364 3.364a.9.9 0 1 1-1.273 1.272L8 9.274l-3.364 3.364a.9.9 0 1 1-1.272-1.273L6.727 8 3.364 4.636a.9.9 0 0 1 0-1.272"
                            clip-rule="evenodd"></path>
                    </svg>
                </div>
                <person ref="person"></person>
            </div>
        </van-popup>
    </div>
</template>

<script>
import person from '@/views/person/index.vue'
export default {
    name: 'my',
    data() {
        return {
            isFirstReload: true
        }
    },
    components: {
        person
    },
    computed: {
        show: {
            get() {
                return this.$store.getters.isShowMyPopup
            },
            set(val) {
                return val
            }
        }
    },
    created() { },
    methods: {
        close() {
            this.$store.dispatch('user/setIsShowMyPopup', false)
        },
        open() {
            this.$nextTick(() => {
                this.$refs.person.init()
            })
        }
    }
}
</script>

<style scoped lang="scss">
@import '@/common/styles/viriables.scss';

.popup {

    .van-popup {
        background: transparent;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;

        .content {
            min-height: 500px;
            width: 470px;
            max-height: calc(100% - 48px);
            max-width: calc(100% - 48px);
            margin: 24px;
            pointer-events: auto;
            contain: layout;
            outline: none;
            background: $bg-box-color;
            border: 1px solid $border-color;
            border-radius: 20px !important;
            display: flex;
            flex-direction: column;
            // overflow: auto;

            .header{
                font-size: 20px;
                margin: 20px 20px 10px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                color: #eef8ff;
                font-size: .36rem;
                text-shadow: 0 1px 2px rgba(6, 26, 58, 0.32);

                svg{
                    width: .42rem;
                    height: .42rem;
                    color: #d7efff;
                    cursor: pointer;
                }
            }

            ::v-deep .pages{
                background: transparent;
                flex: 1;
                overflow: auto;
            }

            ::v-deep .pages::-webkit-scrollbar {
                width: 8px;
            }

            ::v-deep .pages::-webkit-scrollbar-thumb {
                background: linear-gradient(180deg, #54d9ff 0%, #1b86ff 100%);
                border-radius: 999px;
            }

            ::v-deep .pages::-webkit-scrollbar-track {
                background: rgba(220, 243, 255, 0.08);
                border-radius: 999px;
            }

            ::v-deep .pages .func_btns > div {
                background:
                    linear-gradient(180deg, rgba(239, 251, 255, .18) 0%, rgba(239, 251, 255, .06) 24%, rgba(239, 251, 255, 0) 25%),
                    linear-gradient(90deg, rgba(24, 105, 206, .92) 0%, rgba(14, 74, 153, .94) 48%, rgba(8, 39, 82, .96) 100%) !important;
                color: #f5fbff !important;
                border: 1px solid rgba(120, 210, 255, .22) !important;
                box-shadow: inset 0 1px 0 rgba(239, 251, 255, .18), 0 .05rem .12rem rgba(4, 16, 34, .12) !important;
            }

            ::v-deep .pages .func_btns > div:first-child {
                background:
                    linear-gradient(180deg, rgba(243, 252, 255, .24) 0%, rgba(243, 252, 255, .08) 26%, rgba(243, 252, 255, 0) 27%),
                    linear-gradient(90deg, rgba(83, 231, 255, 1) 0%, rgba(41, 185, 255, .99) 42%, rgba(22, 111, 240, .96) 100%) !important;
                color: #f8fcff !important;
                border-color: rgba(142, 227, 255, .42) !important;
                box-shadow: inset 0 1px 0 rgba(243, 252, 255, .3), 0 .08rem .18rem rgba(8, 77, 155, .2) !important;
            }

            ::v-deep .pages .func_btns > div:last-child {
                background:
                    linear-gradient(180deg, rgba(235, 248, 255, .12) 0%, rgba(235, 248, 255, .04) 24%, rgba(235, 248, 255, 0) 25%),
                    linear-gradient(90deg, rgba(32, 122, 223, .94) 0%, rgba(17, 86, 176, .96) 48%, rgba(8, 45, 99, .98) 100%) !important;
                color: #eef8ff !important;
                border: 1px solid rgba(118, 208, 255, .26) !important;
                box-shadow: inset 0 1px 0 rgba(239, 251, 255, .16), 0 .05rem .12rem rgba(4, 16, 34, .14) !important;
            }
        }
    }
}
</style>
